import { Icon } from "@chakra-ui/react"

export const ImageIcon = (props: any) => (
  <Icon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 93.66 104.93">
    <g>
      <path fill="currentColor" className="st0" d="M78.21,10.6H15.46c-5.78,0-10.49,4.7-10.49,10.49v49.19v13.57c0,5.78,4.7,10.49,10.49,10.49h53.48h9.27
        c5.78,0,10.49-4.7,10.49-10.49V21.09C88.69,15.31,83.99,10.6,78.21,10.6z M8.1,21.09c0-4.05,3.3-7.35,7.35-7.35h62.75
        c4.05,0,7.35,3.3,7.35,7.35v50.48L70.23,53.49c-1.17-1.38-2.88-2.18-4.69-2.18c0,0,0,0-0.01,0c-1.81,0-3.53,0.79-4.7,2.18
        L49.27,67.13l-16.36-19.3c-1.17-1.38-2.88-2.18-4.69-2.18c0,0,0,0-0.01,0c-1.81,0-3.53,0.79-4.7,2.18L8.1,66V21.09z M8.1,83.84
        V70.85l17.8-21c0.58-0.68,1.42-1.07,2.31-1.07c0,0,0,0,0,0c0.89,0,1.72,0.39,2.3,1.07l35.04,41.34h-50.1
        C11.4,91.19,8.1,87.89,8.1,83.84z M78.21,91.19h-8.54L51.32,69.55l11.9-14.04c0.58-0.68,1.42-1.07,2.31-1.07c0,0,0,0,0,0
        c0.89,0,1.72,0.39,2.3,1.07l17.72,20.91v7.42C85.56,87.89,82.26,91.19,78.21,91.19z"/>
      <path fill="currentColor" className="st0" d="M50.95,41.05c4.57,0,8.29-3.72,8.29-8.29s-3.72-8.29-8.29-8.29s-8.29,3.72-8.29,8.29S46.38,41.05,50.95,41.05z
        M50.95,27.61c2.84,0,5.15,2.31,5.15,5.15s-2.31,5.15-5.15,5.15c-2.84,0-5.15-2.31-5.15-5.15S48.11,27.61,50.95,27.61z"/>
    </g>
  </Icon>
);
